/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GuardianAngelResponse = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        roomId: {
    type: 'number',
    isRequired: true,
},
        employeeId: {
    type: 'number',
    isRequired: true,
},
        primaryGuardian: {
    type: 'number',
    isRequired: true,
},
        employeeName: {
    type: 'string',
},
    },
};